import { categoryEstimationConfig } from "sj-ui-toolkit/src/atlas/utils/kaConstants";

function calculateDueDate(scheduleObj) {
  const { availableAt, dueAfter } = scheduleObj;

  const startDate = new Date(availableAt);
  startDate.setDate(startDate.getDate() + dueAfter.days);

  return startDate.toISOString();
}

export function generateEstimatedTime(sections) {
  let estimatedTime = [0, 0]; // [min, max] in minutes
  sections.forEach(section => {
    const sectionEstimation = categoryEstimationConfig[section];
    if (sectionEstimation) {
      const min = parseInt(sectionEstimation.estFinishTime.split(" - ")[0]);
      const max = parseInt(sectionEstimation.estFinishTime.split(" - ")[1]);
      estimatedTime[0] += min;
      estimatedTime[1] += max;
    }
  });
  return `${estimatedTime[0]} - ${estimatedTime[1]}`;
}

// SHRPA-2566: This endpoint will change before release, we need to update the hardcoded values when they're ready
export function formatAssessmentData(filteredAssessments) {
  return filteredAssessments
    .slice()
    .sort((a, b) => {
      const isAInProgress = a.content?.knowledgeAssessment?.status?.progress === "InProgress";
      const isBInProgress = b.content?.knowledgeAssessment?.status?.progress === "InProgress";
      return Number(isBInProgress) - Number(isAInProgress);
    })
    .map(assessment => {
      // calculate estimated time based on each category/section (e.g. topicPrefix)
      const estimatedTime = generateEstimatedTime(
        assessment.content.knowledgeAssessment.configuration.filters.sections
      );

      return {
        id: assessment.assignmentTaskUuid,
        type: "Assessment",
        status: assessment.content.knowledgeAssessment.status.progress,
        title: assessment.listing.title,
        description: assessment.listing.description,
        dueDate: calculateDueDate(assessment.schedule.dates),
        points: 200, // TODO: need this data from API
        questions: 20, // TODO: need this data from API
        estimatedTime: estimatedTime,
        locked: false, // Unclear if we need this anymore with assignmentTaskUuid
        assignmentUUID: assessment.assignment.uuid,
      };
    });
}
